import { Outlet } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import Breadcrumbs from "./comp/Breadcrumbs";

import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarSmall from "./SidebarSmall";
import { useEffect, useState } from "react";
import { sideBarShowReducer, sideBarShowReducerSmall } from "../../reducers/layoutSlice";
import { ClipLoader } from "react-spinners";
import ScrollTopButton from "./ScrollTopButton";

export default function Layout() {
  const spinner = useAppSelector((state) => state.spinner.loading);
  const sideBarShow = useAppSelector((state) => state.layout.sideBarShow);
  const sideBarShowSmall = useAppSelector((state) => state.layout.sideBarShowSmall);
  const dispatch = useAppDispatch();
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    if (width > 768 && width < 1200) {
      dispatch(sideBarShowReducer(false));
    } else if (width < 768) {
      dispatch(sideBarShowReducerSmall(true));
    }

    const resizeListener = () => {
      // change width from the state object
      var innerWidth = window.innerWidth;
      if (innerWidth < 768) {
        dispatch(sideBarShowReducer(true));
      } else if (innerWidth < 1200) {
        dispatch(sideBarShowReducer(false));
      } else {
        dispatch(sideBarShowReducer(true));
      }

      if (innerWidth < 768) {
        dispatch(sideBarShowReducerSmall(true));
      } else {
        dispatch(sideBarShowReducerSmall(false));
      }
    };

    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, []);

  return (
    <>
      {spinner && (
        <div className="progress-spinner text-center">
          <ClipLoader loading={true} size={60} color="#4a5aa2" />
        </div>
      )}
      <div id="wrapper">
        <Header />
        {!sideBarShowSmall ? <Sidebar /> : <SidebarSmall />}
        <ScrollTopButton></ScrollTopButton>
        <div className="content-wrapper">
          <div className="container-full">
            <section className="content">
              <Outlet />
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
